import { combineSlices, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
//import { counterSlice } from "../unused functions to delete/counter/counterSlice";
//import { quotesApiSlice } from "../unused functions to delete/quotes/quotesApiSlice";
import mediaSlice from "../slices/media/mediaSlice";
import releaseNotesSlice from "../slices/releaseNotes/releaseNotesSlice";
//import { apiSlice } from "../slices/api/apiSlice";
import { listenerMiddleware } from "./listenerMiddleware";
import currentUserSlice from "../slices/currentUser/currentUserSlice";
import resourceCollectionSlice from "../slices/resourceCollection/resourceCollectionSlice";
import changedResourcesListSlice from "../slices/changedResourcesList/changedResourcesListSlice";
import editModeSlice from "../slices/editMode/editModeSlice";
import footerSlice from "../slices/footer/footerSlice";
import tabPaneSlice from "../slices/tabPane/tabPaneSlice";
import browserTabTitleSlice from "../slices/browserTabTitle/browserTabTitleSlice";
import navigationPanelSlice from "../slices/navigationPanel/navigationPanelSlice";
import viewingOlderVersionSlice from "../slices/viewingOlderVersion/viewingOlderVersionSlice";
import environmentSlice from "../slices/environment/environmentSlice";
import globalLoadingSlice from "../slices/globalLoading/globalLoadingSlice";
import triggerRefreshSlice from "../slices/triggerRefresh/triggerRefreshSlice";
import foiOfFocusSlice from "../slices/foiOfFocus/foiOfFocusSlice";
import relatedResourceCollectionSlice from "../slices/relatedResourceCollection/relatedResourceCollectionSlice";
import notificationsSlice from "../slices/notifications/notificationsSlice";
import outcomeImportanceSlice from "../slices/outcomreImportance/outcomeImpotanceSlice";
import baselineRiskSlice from "../slices/baselineRisk/baselineRiskSlice";
import outcomeVariablesSlice from "../slices/outcomeVariables/outcomeVariablesSlice";
import comparativeEvidenceMapSlice from "../slices/comparativeEvidenceMap/comparativeEvidenceMapSlice";
import netEffectContributionsSlice from "../slices/netEffectContributions/netEffectContributionsSlice";
import summaryOfFindingsSlice from "../slices/summaryOfFindings/summaryOfFindingsSlice";
import topSectionsSlice from "../slices/topSections/topSectionsSlice";
import colorSchemeSlice from "../slices/colorScheme/colorSchemeSlice";
import savedSearchesSlice from "../slices/savedSearches/savedSearchesSlice";
import evidenceTableMapSlice from "../slices/evidenceTableMap/evidenceTableMapSlice";
import searchSettingsSlice from "../slices/searchSettings/searchSettingsSlice";
import fevirSearchResultsSlice from "../slices/fevirSearchResults/fevirSearchResultsSlice";
import myFevirExpandedSlice from "../slices/myFevirExpanded/myFevirExpandedSlice";
import codeSystemTermDetailSlice from "../slices/codeSystemTermDetail/codeSystemTermDetailSlice";
import userImportanceRatingsSlice from "../slices/userImportanceRatings/userImpotanceRatingsSlice";
import trackChangesSlice from "../slices/trackChanges/trackChangesSlice";
import m11StepCountSlice from "../slices/m11StepCount/m11StepCountSlice";
import m11ReportAuthoringToolSlice from "../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";

// `combineSlices` automatically combines the reducers using
// their `reducerPath`s, therefore we no longer need to call `combineReducers`.
const rootReducer = combineSlices(baselineRiskSlice, browserTabTitleSlice, changedResourcesListSlice,
  codeSystemTermDetailSlice, colorSchemeSlice, comparativeEvidenceMapSlice, currentUserSlice,
  editModeSlice, environmentSlice, evidenceTableMapSlice,
  fevirSearchResultsSlice, foiOfFocusSlice, footerSlice,
  globalLoadingSlice, m11ReportAuthoringToolSlice,
  m11StepCountSlice, mediaSlice, myFevirExpandedSlice,
  navigationPanelSlice, netEffectContributionsSlice, notificationsSlice,
  outcomeImportanceSlice, outcomeVariablesSlice,
  relatedResourceCollectionSlice, 
  releaseNotesSlice, resourceCollectionSlice,
  savedSearchesSlice, searchSettingsSlice, summaryOfFindingsSlice,
  tabPaneSlice, topSectionsSlice, trackChangesSlice, triggerRefreshSlice, 
  userImportanceRatingsSlice,
  viewingOlderVersionSlice)

// The store setup is wrapped in `makeStore` to allow reuse
// when setting up tests that need the same store config
export const makeStore = preloadedState => {
  const store = configureStore({
    reducer: rootReducer,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: getDefaultMiddleware => {
      return getDefaultMiddleware().prepend(listenerMiddleware.middleware)
      //.concat(quotesApiSlice.middleware);
    },
    preloadedState,
  });
  // configure listeners using the provided defaults
  // optional, but required for `refetchOnFocus`/`refetchOnReconnect` behaviors
  setupListeners(store.dispatch);
  return store;
};

export const store = makeStore();
